import {
  APP_INIT,
  APP_SHUTDOWN,
  ETH_FEE_UPDATED,
  ETH_FEE_UPDATE_FAILED,
  CAT_FEE_UPDATED,
  CAT_FEE_UPDATE_FAILED,
  LATEST_BLOCK_NUMBER_UPDATED,
  LATEST_BLOCK_NUMBER_UPDATE_FAILED,
  RECOMMENDED_GAS_PRICES_UPDATED,
  RECOMMENDED_GAS_PRICES_UPDATE_FAILED,
} from '../actionTypes';

export const appInit = (
  rewardsContractAddress,
  catTokenAddress,
  catPaymentContractAddress,
  expectedNetwork,
  defaultTokenList,
  abandonCampaignCreationMessage,
  abandonRewardsDownloadMessage,
  appUrl,
  supportedWallets,
) => ({
  type: APP_INIT,
  rewardsContractAddress,
  catTokenAddress,
  catPaymentContractAddress,
  expectedNetwork,
  defaultTokenList,
  abandonCampaignCreationMessage,
  abandonRewardsDownloadMessage,
  appUrl,
  supportedWallets,
});

export const appShutdown = () => ({
  type: APP_SHUTDOWN,
});

export const ethFeeUpdated = ethFee => ({
  type: ETH_FEE_UPDATED,
  ethFee,
});

export const ethFeeUpdateFailed = error => ({
  type: ETH_FEE_UPDATE_FAILED,
  error,
});

export const catFeeUpdated = catFee => ({
  type: CAT_FEE_UPDATED,
  catFee,
});

export const catFeeUpdateFailed = error => ({
  type: CAT_FEE_UPDATE_FAILED,
  error,
});

export const latestBlockNumberUpdated = blockNumber => ({
  type: LATEST_BLOCK_NUMBER_UPDATED,
  blockNumber,
});

export const latestBlockNumberUpdateFailed = error => ({
  type: LATEST_BLOCK_NUMBER_UPDATE_FAILED,
  error,
});

export const appRenderError = (error, extraInfo) => async (
  dispatch,
  getState,
  { errorReporter },
) => {
  errorReporter(error, extraInfo);
};

export const fetchRecommendedGasPricesUpdate = recommendedGasPrices => ({
  type: RECOMMENDED_GAS_PRICES_UPDATED,
  recommendedGasPrices,
});

export const fetchRecommendedGasPricesUpdateFailed = error => ({
  type: RECOMMENDED_GAS_PRICES_UPDATE_FAILED,
  error,
});



// WEBPACK FOOTER //
// ./src/actions/app.js